<template>
  <div
    class="min-h-screen flex items-center justify-center bg-ds-bckgnd-color p-6"
  >
    <div
      class="w-full max-w-3xl bg-white rounded-2xl shadow-2xl overflow-hidden"
    >
      <div class="bg-header-bg-color px-6 py-5">
        <h2 class="text-2xl font-bold text-white text-center tracking-tight">
          Agent Application Form
        </h2>
        <p class="text-sm text-gray-100 text-center mt-1">
          Complete all sections to continue
        </p>
      </div>
      <div class="px-8 py-8">
        <h3 class="text-xl font-bold text-txt-primary-color mb-5 border-b pb-2">
          {{ pageTitles[currentPage - 1] }}
        </h3>
        <component
          :is="pages[currentPage - 1]"
          :formData="formData"
          @update:formData="({ field, value }) => (formData[field] = value)"
          @otacValidated="isOtacValid = $event"
          @brokerCodeDetected="handleBrokerCode"
          :ref="
            currentPage === 1
              ? 'agentRef'
              : currentPage === 2
              ? 'uploadsRef'
              : 'emergencyRef'
          "
        />
      </div>
      <div class="px-8 pb-8">
        <HeroPagination
          :currentPage="currentPage"
          :totalPages="pages.length"
          @next="nextPage"
          @prev="prevPage"
          @submit="submitForm"
        />
      </div>
      <div
        class="bg-gray-50 border-t border-gray-200 py-4 text-center text-sm text-gray-500"
      >
        © 2025 IMS Wellth Care, Inc. All rights reserved.
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, inject } from "vue";
import AgentDetails from "@/pages/Steps/AgentDetails.vue";
import InCaseEmergency from "@/pages/Steps/InCaseEmergency.vue";
import UploadDocuments from "@/pages/Steps/UploadDocuments.vue";
import HeroPagination from "@/components/common/HeroPagination.vue";
import ReviewDetails from "@/pages/Steps/ReviewDetails.vue";
import { useRouter } from "vue-router";
export default {
  components: {
    AgentDetails,
    InCaseEmergency,
    UploadDocuments,
    HeroPagination,
    ReviewDetails,
  },
  setup() {
    const Swal = inject("$swal");
    const axios = inject("$axios");
    const router = useRouter();
    const currentPage = ref(1);
    const pages = [
      AgentDetails,
      UploadDocuments,
      InCaseEmergency,
      ReviewDetails,
    ];
    const agentRef = ref(null);
    const uploadsRef = ref(null);
    const emergencyRef = ref(null);
    const isOtacValid = ref(false);

    const formData = reactive({
      name: "",
      brokercode: "865416",
      birthdate: "",
      address: "",
      email: "",
      broker: "",
      designation: "Account Officer",
      cellphoneno: "",
      tin: "",
      sss: "",
      otac: "",
      photo: null,
      validid: null,
      resume: null,
      emerName: "",
      emerAddress: "",
      emerCellphoneno: "",
      addedByUserid: "1",
    });

    const pageTitles = [
      "Agent Details",
      "Upload Documents",
      "In Case of Emergency",
      "Review All Details",
    ];

    const submitForm = async () => {
      try {
        const payload = new FormData();
        for (const key in formData) {
          const value = formData[key];
          if (value !== null && value !== undefined) {
            payload.append(key, value);
          }
        }
        const response = await axios.post("/agent/detail", payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (response.data.status === false) {
          await Swal.fire({
            title: "Notice",
            text: response.data.message,
            icon: "warning",
            confirmButtonText: "OK",
            confirmButtonColor: "#f6ad55",
          });
          return;
        }

        await Swal.fire({
          title: "Thank you!",
          text: "Your registration has been submitted successfully.",
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "#3085d6",
        });

        router.replace("/thank-you");
      } catch (error) {
        await Swal.fire({
          title: "Error",
          text:
            error.response?.data?.message ||
            "Something went wrong while submitting your registration.",
          icon: "error",
          confirmButtonText: "Try Again",
          confirmButtonColor: "#d33",
        });
      }
    };

    const nextPage = () => {
      if (currentPage.value === 1) {
        const formEl = agentRef.value?.agentForm;
        if (formEl && !formEl.reportValidity()) return;

        if (!isOtacValid.value) {
          return;
        }
      } else if (currentPage.value === 2) {
        if (!formData.photo || !formData.validid || !formData.resume) {
          alert("Please upload all required documents before proceeding.");
          return;
        }
      } else if (currentPage.value === 3) {
        const formEl = emergencyRef.value?.$refs?.emergencyForm;
        if (formEl && !formEl.reportValidity()) return;
      }

      if (currentPage.value < pages.length) {
        currentPage.value++;
      }
    };

    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--;
      }
    };

    const handleBrokerCode = (code) => {
      console.log("✅ Broker code detected:", code);
      formData.brokercode = code;
    };

    return {
      currentPage,
      pages,
      formData,
      submitForm,
      nextPage,
      prevPage,
      agentRef,
      uploadsRef,
      emergencyRef,
      isOtacValid,
      pageTitles,
      handleBrokerCode,
    };
  },
};
</script>
